/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    StbGroupByDeviceTypeResponse,
    StbGroupByDeviceTypeResponseFromJSON,
    StbGroupByDeviceTypeResponseFromJSONTyped,
    StbGroupByDeviceTypeResponseToJSON,
} from './StbGroupByDeviceTypeResponse';

/**
 * 
 * @export
 * @interface StbGroupsByDeviceTypeResponse
 */
export interface StbGroupsByDeviceTypeResponse {
    /**
     * 
     * @type {Array<StbGroupByDeviceTypeResponse>}
     * @memberof StbGroupsByDeviceTypeResponse
     */
    stbGroups?: Array<StbGroupByDeviceTypeResponse>;
    /**
     * 
     * @type {number}
     * @memberof StbGroupsByDeviceTypeResponse
     */
    count?: number;
}

export function StbGroupsByDeviceTypeResponseFromJSON(json: any): StbGroupsByDeviceTypeResponse {
    return StbGroupsByDeviceTypeResponseFromJSONTyped(json, false);
}

export function StbGroupsByDeviceTypeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): StbGroupsByDeviceTypeResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stbGroups': !exists(json, 'stbGroups') ? undefined : ((json['stbGroups'] as Array<any>).map(StbGroupByDeviceTypeResponseFromJSON)),
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}

export function StbGroupsByDeviceTypeResponseToJSON(value?: StbGroupsByDeviceTypeResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stbGroups': value.stbGroups === undefined ? undefined : ((value.stbGroups as Array<any>).map(StbGroupByDeviceTypeResponseToJSON)),
        'count': value.count,
    };
}

